// global functions
import router from 'assets/router';

import {
  footer,
  header,
  headerPromo,
  newsletterModal,
} from 'assets/components';

import {
  detectShopifyEditor,
  hasMouse,
  images,
  loadSprite,
  scrolling,
  scrollingCallbacks, // eslint-disable-line no-unused-vars
} from 'assets/utilities';

import 'assets/site.scss';

/*  eslint-disable */
// NOTE: syntax used to confrom with SvgStore npm module
const __svg__ = {
  name: 'icons.svg',
  path: './icons/*.svg',
};
/*  eslint-enable */

footer.init();
header.init();
headerPromo.init();
loadSprite();
images.init();
scrolling.init();
router.init();
router.addCallback(header.close);
hasMouse.init();
newsletterModal.init();
detectShopifyEditor();

if (typeof module !== 'undefined' && module.hot) {
  module.hot.accept();
  // Disable CSS for HMR
  document.getElementsByTagName('link')[0].disabled = true;
}
